module.exports = __webpack_public_path__ + "static/media/IMG_20220411_151647_999.d03ae2bc.jpg";